module.exports = __webpack_public_path__ + "static/media/fiber-optic-cables.d5d42fb5.jpg";